jQuery(function($) {
  var $obj = $(document).find('#instafeed-gallery-feed');

  if ($obj.length != 0) {
    var galleryFeed = new Instafeed({
      get: 'user',
      userId: 8798934537,
      accessToken: '8798934537.21e3e71.10689837a417446086512ff704abfc88',
      resolution: 'standard_resolution',
      useHttp: 'true',
      limit: 10,
      template:
        '<a href="{{link}}">' +
        '<div class="img-featured-container">' +
        '<div class="img-backdrop"></div>' +
        '<div class="description-container">' +
        '<p class="caption">{{caption}}</p>' +
        '<!--<span class="likes"><i class="icon ion-heart"></i> {{likes}}</span>-->' +
        '<!--<span class="comments"><i class="icon ion-chatbubble"></i> {{comments}}</span>-->' +
        '</div>' +
        '<img src="{{image}}" class="img-responsive">' +
        '</div>' +
        '</a>',
      target: 'instafeed-gallery-feed',
      after: function() {
        // disable button if no more results to load
        //if (!this.hasNext()) {
        //  btnInstafeedLoad.setAttribute('disabled', 'disabled');
        //}

        var owl = $('.instag'),
          owlSlideSpeed = 300;

        // init owl
        $(document).ready(function() {
          owl.owlCarousel({
            // navContainer: '.owl-nav-custom',
            // dotsContainer: '.owl-dots-custom',
            autoplay: true,
            dots: false,
            margin: 10,
            loop: true,
            margin: 10,
            nav: false,
            responsive: {
              0: {
                items: 1
              },
              200: {
                items: 2
              },
              400: {
                items: 3
              },
              768: {
                items: 5
              }
            }
          });
          /*
          $('.testimo').owlCarousel({
            items: 1,
            loop: true,
            margin: 10,
            nav: false,
            dots: true
            //autoplay: true,
            //autoplayTimeout: 30800
          });*/
        });

        // keyboard controls
        $(document.documentElement).keydown(function(event) {
          if (event.keyCode == 37) {
            owl.trigger('prev.owl.carousel', [owlSlideSpeed]);
          } else if (event.keyCode == 39) {
            owl.trigger('next.owl.carousel', [owlSlideSpeed]);
          }
        });
      }
    });

    galleryFeed.run();
  }

  //Form send mail
  var url = window.location.href;
  var arr = url.split('/');
  var result = arr[0] + '//' + arr[2];

  var domain = result;
  var themeUri = '/wp-content/themes/pratyaharatheme';

  var fullUrl = domain + themeUri;

  var urldev = 'http://192.168.15.3:8080/UPMB/contact/process-form.php';
  var urlprod = fullUrl + '/contact/process-form.php';

  var $objform = $(document).find('#contactForm');
  if ($objform.length != 0) {
    try {
      jQuery('#contactForm').validate({
        submitHandler: function() {
          var postvalues = jQuery('#contactForm').serialize();
          //alert(postvalues);
          jQuery.ajax({
            type: 'POST',
            url: urlprod,
            data: postvalues,
            success: function(response) {
              console.log(response);
              jQuery('#status')
                .html(response)
                .show('normal');
              jQuery('#nome, #email, #assunto, #mensagem').val('');
            }
          });
          return false;
        },
        focusInvalid: true,
        focusCleanup: false,
        //errorLabelContainer: jQuery('#registerErrors'),
        rules: {
          nome: { required: true },
          assunto: { required: true },
          email: {
            required: true,
            minlength: 6,
            maxlength: 50,
            email: true
          },
          celular: { required: true },
          mensagem: { required: true, minlength: 6 }
        },

        messages: {
          nome: { required: 'Este campo é obrigatório' },
          assunto: { required: 'Este campo é obrigatório' },
          email: {
            required: 'Este campo é obrigatório',
            email: 'Por favor forneça um email válido'
          },
          celular: { required: 'Este campo é obrigatório' },
          mensagem: { required: 'Este campo é obrigatório' }
        },

        errorPlacement: function(error, element) {
          error.insertBefore(element);
          jQuery('<span class="errorarr"></span>').insertBefore(element);
        },
        invalidHandler: function() {
          //jQuery("body").animate({ scrollTop: 0 }, "slow");
        }
      });
    } catch (err) {
      alert(
        'Something went wrong, please check the settings in contact/contact.php file.'
      );
    }
  }

  /* Newsletter */

  var n_urldev = 'http://192.168.15.3:8080/UPMB/contact/process-newsletter.php';
  var n_urlprod = fullUrl + '/contact/process-newsletter.php';

  var $objNews = $(document).find('#newsForm');
  if ($objNews.length != 0) {
    try {
      jQuery('#newsForm').validate({
        submitHandler: function() {
          var postvalues = jQuery('#newsForm').serialize();
          //alert(postvalues);
          jQuery.ajax({
            type: 'POST',
            url: n_urlprod,
            data: postvalues,
            success: function(response) {
              console.log(response);
              jQuery('#status')
                .html(response)
                .show('normal');
              jQuery('#nome, #email').val('');
            }
          });
          return false;
        },
        focusInvalid: true,
        focusCleanup: false,
        //errorLabelContainer: jQuery('#registerErrors'),
        rules: {
          nome: { required: true },
          email: {
            required: true,
            minlength: 6,
            maxlength: 50,
            email: true
          }
        },
        messages: {
          nome: { required: 'Este campo é obrigatório' },
          email: {
            required: 'Este campo é obrigatório',
            email: 'Por favor forneça um email válido'
          }
        },
        errorPlacement: function(error, element) {
          error.insertBefore(element);
          jQuery('<span class="errorarr"></span>').insertBefore(element);
        },
        invalidHandler: function() {
          //jQuery("body").animate({ scrollTop: 0 }, "slow");
        }
      });
    } catch (err) {
      alert(
        'Something went wrong, please check the settings in contact/contact.php file.'
      );
    }
  }

  //Testimony send
  var $formTest = $(document).find('#testimony-form');
  if ($formTest.length != 0) {
    try {
      jQuery('#testimony-form').validate({
        submitHandler: function() {
          var postvalues = $('#testimony-form').serializeArray(); // convert form to array

          var imgProfiler = $(document).find('.profile-face');
          if (imgProfiler != 0) {
            var $urlImg = $('.profile-face').attr('src');
          }

          postvalues.push({ name: 'image', value: $urlImg });

          jQuery.ajax({
            type: 'POST',
            url: fullUrl + '/testimony/testimony.php',
            data: postvalues,
            success: function(response) {
              console.log(response);
              jQuery('#status-test')
                .html(response)
                .show('normal');
              jQuery('#nome, #mensagem').val('');
            }
          });
          return false;
        },
        focusInvalid: true,
        focusCleanup: false,
        //errorLabelContainer: jQuery('#registerErrors-test'),
        rules: {
          nome: { required: true },
          mensagem: { required: true }
        },
        messages: {
          nome: { required: 'Este campo é obrigatório' },
          mensagem: { required: 'Este campo é obrigatório' }
        },
        errorPlacement: function(error, element) {
          error.insertBefore(element);
          jQuery('<span class="errorarr"></span>').insertBefore(element);
        },
        invalidHandler: function() {
          //jQuery("body").animate({ scrollTop: 0 }, "slow");
        }
      });
    } catch (err) {
      alert(
        'Something went wrong, please check the settings in contact/contact.php file.'
      );
    }
  }

  //Testimony Load
  $('#load-testimony1').html('');
  var url = fullUrl + '/testimony/testimony-load.php';
  $.getJSON(url, function(data) {
    if (data != 0) {
      $('.t-loads').css('display', 'block');
      $.each(data, function(index, element) {
        var item =
          '<div class="item">' +
          '<div class="row">' +
          '<div class="col-lg-3">' +
          '<img class="picture-face" src="' +
          element.testimony_url_photo_face +
          '" />' +
          '</div>' +
          '<div class="col-lg-9 text-testi">' +
          '<p class="coments-text">' +
          element.testimony_content +
          '</p>' +
          '<h6>- ' +
          element.testimony_author +
          '</h6>' +
          '</div>' +
          '</div>' +
          '</div>';

        $('#load-testimony1').append(item);

        //$('.autor').text(element.testimony_author);
        //$('.coments-text').text(element.testimony_content);
        //$('.picture-face').attr('src', element.testimony_url_photo_face);
        console.log('autor' + element.testimony_url_photo_face);
      });
    } else {
      $('.t-loads').css('display', 'none');
    }
  });
});

//Facebook
// initialize and setup facebook js sdk
window.fbAsyncInit = function() {
  FB.init({
    appId: '336115307251174',
    xfbml: true,
    version: 'v3.2'
  });

  FB.getLoginStatus(function(response) {
    if (response.status === 'connected') {
      document.getElementById('status').innerHTML = 'connected';
      document.getElementById('login').style.visibility = 'hidden';
      getInfo();
      document.getElementById('content-form').style.visibility = 'visible';
      document.getElementById('content-form').style.height = '300px';
    } else if (response.status === 'not_authorized') {
      document.getElementById('status').innerHTML = 'We are not logged in.';
      document.getElementById('content-form').style.visibility = 'hidden';
    } else {
      document.getElementById('status').innerHTML =
        'You are not logged into Facebook.';
      document.getElementById('content-form').style.visibility = 'hidden';
    }
    console.log(response);
  });
};

(function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = '//connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');

// login with facebook with extra permissions
function login() {
  FB.login(
    function(response) {
      if (response.status === 'connected') {
        document.getElementById('status').innerHTML = 'connected';
        document.getElementById('login').style.visibility = 'hidden';
        getInfo();
        document.getElementById('content-form').style.visibility = 'visible';
        document.getElementById('content-form').style.height = '300px';
      } else if (response.status === 'not_authorized') {
        document.getElementById('status').innerHTML = 'We are not logged in.';
        document.getElementById('content-form').style.visibility = 'hidden';
      } else {
        document.getElementById('status').innerHTML =
          'You are not logged into Facebook.';
        document.getElementById('content-form').style.visibility = 'hidden';
      }
    },
    { scope: 'email' }
  );
}

// getting basic user info
function getInfo() {
  FB.api(
    '/me',
    'GET',
    { fields: 'first_name,last_name,name,id,picture.width(250).height(250)' },
    function(response) {
      document.getElementById('status').innerHTML =
        "<img class='profile-face' src='" + response.picture.data.url + "'>";
    }
  );
}
